import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  RoofMaterialTypeForm,
  RoofMaterialTypeListMeta,
  RoofMaterialTypeRow,
} from "../types";
import { initialRoofMaterialTypeForm, initialState } from "./initialState";

export const sliceKey = "roofMaterialTypeState";

type RoofMaterialTypeListSuccessPayload = {
  data: RoofMaterialTypeRow[];
  meta: RoofMaterialTypeListMeta;
};

const roofMaterialTypeSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getRoofMaterialTypeList(state) {
      state.loading = true;
      state.error = null;
      state.page = 1;
    },

    getRoofMaterialTypeListSuccess(
      state,
      action: PayloadAction<RoofMaterialTypeListSuccessPayload>
    ) {
      state.loading = false;
      state.list = action.payload.data;
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },

    getRoofMaterialTypeListError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    getNextPageItems(state) {
      if (state.loading || state.meta.currentPage >= state.meta.totalPages) {
        return;
      }
      state.loading = true;
      state.error = null;
      state.page = state.meta.currentPage + 1;
    },

    getNextPageItemsSuccess(
      state,
      action: PayloadAction<RoofMaterialTypeListSuccessPayload>
    ) {
      state.loading = false;
      state.list = state.list.concat(action.payload.data);
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },

    getNextPageItemsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    openAddModal(state) {
      state.isAddModalOpen = true;
      state.error = null;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.saving = false;
      state.error = null;
      state.form = initialRoofMaterialTypeForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof RoofMaterialTypeForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value;
    },

    resetForm(state) {
      state.form = initialRoofMaterialTypeForm;
    },

    addRoofMaterialType(state) {
      state.saving = true;
      state.error = null;
    },

    addRoofMaterialTypeSuccess(state) {
      state.saving = false;
      state.isAddModalOpen = false;
      state.form = initialRoofMaterialTypeForm;
      state.error = null;
    },

    addRoofMaterialTypeError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const { actions: roofMaterialTypeActions, reducer } =
  roofMaterialTypeSlice;
